import React, { useState, useEffect } from "react";

import "../../styles/jischeckbox.css";
import DynamicIcon from "../dynamicicon";

function JisYesNo({
  label,
  value,
  onChange,
  name,
  required = false,
  errorMessage = "This field is required.",
  size = 30,
  yes = "Yes",
  no = "No",
  applyButtonStyle = false,
}) {
  const [touched, setTouched] = useState(false);
  const isInvalid = required && touched && !value;

  const handleToggle = (v) => {
    onChange(v);
    if (!touched) setTouched(true);
  };

  useEffect(() => {
    if (!required) setTouched(false);
  }, [required]);

  return (
    <>
      <div className="question">
        <p className="question-title">{label}</p>
        <div className={`${applyButtonStyle && "groupbtn"}`}>
          <button
            type="button"
            className={`btn-choice ${
              value != null && value ? "active-yes" : ""
            }`}
            id="btn-yes"
            onClick={() => handleToggle(true)}
          >
            {yes}
          </button>
          <button
            type="button"
            className={`btn-choice ${
              value != null && !value ? "active-yes" : ""
            }`}
            id="btn-no"
            onClick={() => handleToggle(false)}
          >
            {no}
          </button>
        </div>
      </div>
    </>
  );
}

export default JisYesNo;
